import { TextKey } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';
import { SettingsLayout } from '../Layout';
import { useGetCurrentUserQuery } from '../../queries/useGetCurrentUsersQuery';
import { useMapUserToProfileFormProps } from '../../utils';
import { ProfileForm } from './ProfileForm';

export const ProfileView = ({ guideLink }: WithGuideLink) => {
    const { data } = useGetCurrentUserQuery();

    const formProps = useMapUserToProfileFormProps(data);

    if (!data) {
        return null;
    }

    return (
        <SettingsLayout guideLink={guideLink} activeTab={TextKey.Profile}>
            <ProfileForm {...formProps} />
        </SettingsLayout>
    );
};
